import { render, staticRenderFns } from "./SquizzySquid.vue?vue&type=template&id=c033740c&scoped=true&"
import script from "./SquizzySquid.vue?vue&type=script&lang=js&"
export * from "./SquizzySquid.vue?vue&type=script&lang=js&"
import style0 from "./SquizzySquid.vue?vue&type=style&index=0&id=c033740c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c033740c",
  null
  
)

export default component.exports